<template>
  <v-row>
    <v-col cols="12">
      <v-select
        v-model="templateEmailSelecionadoIdLocale"
        dense
        outlined
        validate-on-blur
        label="Templates de e-mail"
        placeholder="Templates de e-mail"
        no-data-text="Nenhum template de e-mail disponível"
        item-value="id"
        item-text="nome"
        :readonly="readonly"
        :filled="readonly"
        :loading="loading"
        :items=" templatesEmail"
        @change="v => $emit('update:templateEmailSelecionadoId', v)"
      />
    </v-col>
  </v-row>
</template>

<script>
import { ref, onMounted, watch } from '@vue/composition-api'
import TemplateEmailService from '@/services/modules/TemplateEmailService'

export default {
  emits: ['update:templateEmailSelecionadoId'],

  props: {
    templateEmailSelecionadoId: {
      type: Number,
      default: null,
    },
    readonly: Boolean,
  },

  setup(props) {
    const templatesEmail = ref([])
    const templateEmailSelecionadoIdLocale = ref(null)
    const loading = ref(false)

    watch(
      () => props.templateEmailSelecionadoId,
      v => {
        if (!v) return
        templateEmailSelecionadoIdLocale.value = v
      },
      {
        immediate: true,
      },
    )

    async function getTemplatesEmail() {
      if (loading.value) return
      try {
        loading.value = true
        templatesEmail.value = await TemplateEmailService.get(true, true)
      } finally {
        loading.value = false
      }
    }

    onMounted(getTemplatesEmail)

    return {
      templatesEmail,
      templateEmailSelecionadoIdLocale,
      loading,
    }
  },
}
</script>
